import { Expose } from "class-transformer";

export class ChangeEmployeeDocumentCategoryDto {
  @Expose()
  categoryId: string;
}
